import {
  BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING,
  BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS,
  BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    bdEnvironmentalAndHealthCertification: null,
  }
  
  const bdEnvironmentalAndHealthCertification = (state = initialState, action) => {
    switch (action.type) {
      case BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING:
        state = {
          ...state,
          loading: true,
          bdEnvironmentalAndHealthCertification: action.payload,
        }
        break
      case BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_SUCCESS:
        state = { ...state, loading: false, bdEnvironmentalAndHealthCertification: action.payload }
        break
      case BD_GET_ENVIRONMENTALANDHEALTHCERTIFICATION_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default bdEnvironmentalAndHealthCertification
  